<script lang="ts">
    import { widgetState } from "../store/widget.store";
    export let positioning = 'justify-center'
    export let logoColor = '000000';

    let logoUrl = 'brand.svg';

    if (logoColor === 'ffffff') {
        logoUrl = 'compado_logo_white.svg';
    } else if (logoColor === '000000') {
        logoUrl = 'brand.svg';
    } else {
        logoUrl = 'brand.svg';
    }
</script>
{#if $widgetState.config.brand_choice}
    <div class="brand-logo flex items-center {positioning}">
        <p class="text-xs {positioning}" style="color: #{logoColor}">{$widgetState.config.brand_choice}</p>
        <img src="{logoUrl}" alt="compado"/>
    </div>
{/if}

<style lang="scss">
    .brand-logo {
        grid-area: brand-logo;
    }
</style>